import { render, staticRenderFns } from "./CreateInfoCardModal.vue?vue&type=template&id=3b03215e&scoped=true&"
import script from "./CreateInfoCardModal.vue?vue&type=script&lang=js&"
export * from "./CreateInfoCardModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateInfoCardModal.vue?vue&type=style&index=0&id=3b03215e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b03215e",
  null
  
)

export default component.exports